export class Test {
	constructor(data) {
		this.data = data;
		this.questions = data.test;
		this.results = data.results;
		this.activeIndex = 0;
		this.currentValue = null;
		this.totalResult = 0;
		this.isResultScreen = false;

		this.$number = $(".test__number");
		this.$question = $(".test__question");
		this.$answer = $(".test__answer");
		this.$comment = $(".test__description");
		this.$commentWrap = $(".test__comment");
		this.$nextButton = $(".test__button");
		this.$nextButtonText = $(".test__button .test__button-text");
		this.$questionText = $(".test__text");
		this.$testBottom = $(".test__bottom");

		this.$resultScores = $(".result__scores");
		this.$resultStatus = $(".result__status");
		this.$resultText = $(".result__text");
		this.$resultBg = $(".result__top");
	}

	init() {
		this.handleEvents();
		this.renderQuestion();
	}

	handleEvents = () => {
		this.$answer.on("click", this.handleAnswerClick);
		this.$nextButton.on("click", this.handleNextButtonClick);
	};

	handleAnswerClick = (e) => {
		const value = Number($(e.currentTarget).attr("data-value"));
		this.currentValue = value;

		if (this.activeIndex < this.questions.length) {
			this.$answer.removeClass("is-active");
			$(e.currentTarget).addClass("is-active");
			this.$nextButton.removeClass("is-hidden");
			this.$commentWrap.removeClass("is-hidden");
			this.$testBottom.removeClass("is-hidden");
		}

		if (
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
				navigator.userAgent
			)
		) {
			$("html, body").animate(
				{
					scrollTop: $(".test__wrap").offset().top,
				},
				500
			);
		}
	};

	handleNextButtonClick = () => {
		if (this.currentValue === null) {
			return;
		}

		this.totalResult += this.currentValue;
		this.activeIndex += 1;

		this.$answer.removeClass("is-active");
		this.$nextButton.addClass("is-hidden");
		this.$commentWrap.addClass("is-hidden");
		this.$testBottom.addClass("is-hidden");

		if (this.activeIndex === this.questions.length) {
			this.$nextButton.removeClass("is-hidden");
			this.$commentWrap.removeClass("is-hidden");
			this.$testBottom.removeClass("is-hidden");
			this.renderResults();
			$("html, body").animate(
				{
					scrollTop: $(".result").offset().top,
				},
				500
			);
		} else if (this.activeIndex > this.questions.length) {
			this.activeIndex = 0;
			this.totalResult = 0;
			$(".result__top").removeClass(
				"result__top_1 result__top_2 result__top_3"
			);
			$("body").removeClass("show-result");
			this.$nextButtonText.text("следующий вопрос");
			this.renderQuestion();
		} else {
			this.renderQuestion();
		}
	};

	renderQuestion = () => {
		const currentQuestion = this.questions[this.activeIndex];
		const { question, answers, comment } = currentQuestion;

		this.$nextButton.addClass("is-hidden");
		this.$commentWrap.addClass("is-hidden");
		this.$testBottom.addClass("is-hidden");

		this.$number.text(this.activeIndex + 1);
		this.$question.html(question);
		this.$comment.text(comment);
		this.$questionText.each((i, item) => {
			$(this.$answer[i]).attr("data-value", answers[i].value);
			$(item).html(answers[i].title);
		});

		if (this.activeIndex === this.questions.length - 1) {
			this.$nextButtonText.text("показать результат");
		}
	};

	renderResults = () => {
		let dataIndex;

		if (this.totalResult <= this.results[0].maxValue) {
			dataIndex = 0;
		} else if (this.totalResult <= this.results[1].maxValue) {
			dataIndex = 1;
		} else {
			dataIndex = 2;
		}

		this.$resultScores.text(this.results[dataIndex].scores);
		this.$resultStatus.text(this.results[dataIndex].status);
		this.$resultText.html(this.results[dataIndex].text);
		this.$resultBg.css(
			"background-image",
			`url(./images/result-bg-${dataIndex + 1}.jpg)`
		);

		$("body").addClass("show-result");
		$(".result__top").addClass(`result__top_${dataIndex + 1}`);
		this.$nextButton.removeClass("is-hidden");
		this.$commentWrap.removeClass("is-hidden");
		this.$testBottom.removeClass("is-hidden");
		this.$nextButtonText.text("пройти снова");
	};
}



// WEBPACK FOOTER //
// ./app/scripts/test.js